import { DNA } from "react-loader-spinner";
const Loader = () => {
    return (
        <div style={{
            width: '100%', height: '100%', position: 'absolute',
            backgroundColor: '#0000008c',
            zIndex: 9999,
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <DNA
                visible={true}
                height="120"
                width="120"
                ariaLabel="dna-loading"
                wrapperClass="dna-wrapper"
            />
        </div>
    );
};
export default Loader;